// extracted by mini-css-extract-plugin
export default {"base":"style_base__IAYJ1","info":"style_info__vcwYp","root":"style_root__gJ0zb"};